import React from "react";
import { VStack, Flex } from "@chakra-ui/react";
import { AccordionItem, Checkbox } from "components";
import { StoredAuthorization } from "duck";
import { OrganizationSetting } from "../../../../duck";
import { Actions } from "./components";
import { SelectionContext } from "./duck";

interface AuthorizationsProps {
  organizationSettings: OrganizationSetting;
}

const Authorizations: React.FC<AuthorizationsProps> = ({
  organizationSettings
}) => {
  const [selected, setSelected] = React.useState<StoredAuthorization[]>([]);
  const authorizations =
    organizationSettings.authorizationSettings?.collection || [];

  return (
    <AccordionItem title="Authorizations">
      <SelectionContext.Provider
        value={{
          selected,
          select: auths => setSelected(auths),
          organizationSettingId: organizationSettings._id
        }}
      >
        <Flex direction="column" rowGap={4}>
          <Actions />
          <VStack spacing={6}>
            {authorizations.map(authorization => {
              const isChecked = selected.some(
                auth => auth._id === authorization._id
              );
              return (
                <Checkbox
                  key={authorization._id}
                  label={authorization.condition}
                  isChecked={isChecked}
                  onChange={() => {
                    const newSelected = isChecked
                      ? selected.filter(auth => auth._id !== authorization._id)
                      : [...selected, authorization];
                    setSelected(newSelected);
                  }}
                />
              );
            })}
          </VStack>
        </Flex>
      </SelectionContext.Provider>
    </AccordionItem>
  );
};

export default Authorizations;
